import {StateType} from 'typesafe-actions';
import {Middleware} from 'redux';

import rootReducer from './root-reducer';

import {fetchCalendarItemsMiddleware} from './calendar/middleware';

import * as calendarActions from './calendar/actions';
import * as contestActions from './contest/actions';
import * as dressageProtocolActions from './dressage/actions';
import * as dressageProtocolListActions from './dressagelist/actions';
import {fetchContestItemsMiddleware} from "./contest/middleware";
import {fetchDressageItemMiddleware} from "./dressage/middleware";
import {fetchDressageItemsMiddleware} from "./dressagelist/middleware";

export {default} from './store';
export {default as rootReducer} from './root-reducer';

export const selectors = {};

export const actions = {
  calendaritems: calendarActions,
  contest: contestActions,
  dressageProtocol: dressageProtocolActions,
  dressageProtocolList: dressageProtocolListActions,
};

export const middlewares: Middleware[] = [
  fetchCalendarItemsMiddleware,
  fetchContestItemsMiddleware,
  fetchDressageItemMiddleware,
  fetchDressageItemsMiddleware
];

export type RootState = StateType<typeof rootReducer>;
